import 'apps/hiring/styles/components/cheese.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { strip_tags } from 'library/helpers/text';
import CheeseSliceOverlay from 'apps/hiring/components/cheese-slice-overlay';
import CaretSvg from 'library/icons/caret.svg';
import PropTypes from 'prop-types';


class SortLabel extends React.Component {
  handleClick = () => {
    this.props.onClick(this.props.name);
  }

  render() {
    const {
      sort,
      name,
      dir='DESC',
      children,
      onClick=()=>{},
      ...props
    } = this.props;

    return (
      <span {...props} onClick={this.handleClick}>
        { children }
        {
          name === sort
            ? <CaretSvg data-dir={dir} />
            : null
        }
      </span>
    );
  }
}

SortLabel.propTypes = {
  sort: PropTypes.string,
  name: PropTypes.string,
  dir: PropTypes.string,
  children: PropTypes.array,
  onClick: PropTypes.func,
};

export const CheeseSlice = ({ start=0, end=0, children, className='', ...props }) => (
  <div className={['cheese-slice',className].filter(c=>c).join(' ')} {...props}>
    <div className="cheese-slice-chart">
      <div className="cheese-slice-chart-range" style={{left: `${start}%`, right: `${100-end}%`}} />
    </div>
    { children }
  </div>
);

CheeseSlice.propTypes = {
  start: PropTypes.number,
  end: PropTypes.number,
  children: PropTypes.array,
  className: PropTypes.string,
};

const SORT_CHEESE = {
  name: (A,B,dir) => (
    resolve(A, 'characteristic/name', '').localeCompare(resolve(B, 'characteristic/name', ''))*dir
  ),
  match: (A,B) => (
    0
  )
};

class Cheese extends React.Component {
  constructor(...params) {
    super(...params);

    this.cheeseBodyRef = React.createRef();
  }

  state = {
    sort: 'name',
    dir: 'DESC'
  }

  mapSlices = ({ percentile_range }) => (
    <CheeseSlice {...percentile_range} />
  )

  mapTargetNames = ({ characteristic }) => (
    <div data-tooltip={strip_tags(resolve(characteristic, 'description', ''))} className="cheese-slice-data">
      <span>
        { resolve(characteristic, 'name', '') }
      </span>
    </div>
  )

  setSort = (val) => {
    this.setState({
      sort: val,
      dir: this.state.sort===val&&this.state.dir==='DESC'?'ASC':'DESC'
    });
  }

  mapKeys = ({ title, color}) => (
    <label>
      <div className={['cheese-key applicant key', color].filter(c=>c).join(' ')} />
      <p>{ title }</p>
    </label>
  )

  doSort = (A, B) => (
    (SORT_CHEESE[this.state.sort]||SORT_CHEESE.name)(A,B, this.state.dir==='DESC'?1:-1)
  )

  render() {
    const keyOptions = [
      {title: 'Employees', color: 'currentColor'},
    ];

    resolve(this.props, 'selectedApplicantName', '') == '' ? null : keyOptions.push({title: this.props.selectedApplicantName, color: 'pink'});
    resolve(this.props, 'selectedEmployeeName', '') == '' ? null : keyOptions.push({title: this.props.selectedEmployeeName, color: 'green'});

    const {
      target,
      assessments,
      withRanges,
      withKey
    } = this.props;

    const sorted_targets = resolve(target, 'targets', []).sort(this.doSort);

    return (
      <div className="cheese">
        <div className="cheese-control" style={{ marginRight: withKey ? '163px': null}}>
          <SortLabel sort={this.state.sort} name="match" dir={this.state.dir} onClick={this.setSort}>
            MATCH
          </SortLabel>
          <SortLabel sort={this.state.sort} name="name" dir={this.state.dir} onClick={this.setSort}>
            NAME
          </SortLabel>
        </div>
        <div className="cheese-body" ref={this.ref}>
          <div className="cheese-body-slices">
            {
              withRanges
                ? (
                  <div className="cheese-body-ranges" />
                )
                : null
            }
            {
              sorted_targets.map(this.mapSlices)
            }
            <CheeseSliceOverlay targets={sorted_targets} target={target} assessments={assessments} />
          </div>
          <div className="cheese-body-names">
            {
              sorted_targets.map(this.mapTargetNames)
            }
          </div>
          {
            withKey
              ?
              <div className="cheese-key-options">
                {keyOptions.map(this.mapKeys)}
              </div>
              : null
          }
        </div>
      </div>
    );
  }
}

Cheese.propTypes = {
  target: PropTypes.object,
  assessments: PropTypes.array,
  withRanges: PropTypes.bool,
  withKey: PropTypes.bool,
  selectedApplicantName: PropTypes.string,
  selectedEmployeeName: PropTypes.string
};



export default Cheese;
